import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/zip.js
// module id = 281
// module chunks = 0